import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatDatepickerModule, MatDateRangePicker} from '@angular/material/datepicker';
import {FormGroup, FormsModule} from '@angular/forms';
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { DatePipe } from "@angular/common";
import { TalentProfileApiService } from "../../../talent-profile/talent-profile-api.service";
import { TranslateModule } from '@ngx-translate/core';
import { UtilService } from '../../service/util.service';

@Component({
    selector: 'app-date-range-picker',
    imports: [
        MatButtonModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatInputModule,
        FormsModule,
        TranslateModule
    ],
    templateUrl: './date-range-picker.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './date-range-picker.component.scss'
})
export class DateRangePickerComponent implements OnInit {
  @Input() startDateFormControlName: string;
  @Input() endDateFormControlName: string;
  @Input() selectedStartDate: Date;
  @Input() selectedEndDate: Date;
  @Output() selectedDateRangeChange: EventEmitter<{ startDate: Date, endDate: Date, employmentTypeLabel?: string }> = new EventEmitter<{ startDate: Date, endDate: Date, employmentTypeLabel?: string }>();
  @Input() form: FormGroup;
  @Input() personId: number;
  @Input() employmentTypeLabel: string;
  localeId: number;
  today = new Date();
  formattedDateRange: string;

  constructor(
    private datePipe: DatePipe,
    private utilService: UtilService,
    private profileService: TalentProfileApiService) {}


  ngOnInit(): void {
    const initialStart = this.parseIsoDate(this.form?.get(this.startDateFormControlName)?.value);
    const initialEnd = this.parseIsoDate(this.form?.get(this.endDateFormControlName)?.value);
    if (initialStart) {
      this.selectedStartDate = initialStart;
    }
    if (initialEnd) {
      this.selectedEndDate = initialEnd;
    }

    this.profileService.getLocaleId(this.personId).subscribe(localeId => {
      this.localeId = localeId;
      if (this.selectedStartDate || this.selectedEndDate) {
        this.updateFormattedDateRange();
      }
    });
  }

  onDateRangeChange(picker: MatDateRangePicker<Date>, employmentTypeLabel?: string) {
    this.updateFormattedDateRange();
    this.selectedDateRangeChange.emit({
      startDate: this.selectedStartDate ?? null,
      endDate: this.selectedEndDate ?? null,
      employmentTypeLabel: employmentTypeLabel
    });
  }

  private parseIsoDate(value: string | null | undefined): Date | null {
    if (!value) return null;
    const parts = value.split('-');
    if (parts.length === 3) {
      const [y, m, d] = parts.map(Number);
      if (y && m && d) {
        const date = new Date(y, m - 1, d); // local midnight, no TZ shift
        return isNaN(date.getTime()) ? null : date;
      }
    }
    const fallback = new Date(value);
    return isNaN(fallback.getTime()) ? null : fallback;
  }

  private updateFormattedDateRange(): void {
    const fmt = this.utilService.getDateFormat(this.localeId);
    const start = this.selectedStartDate ? this.datePipe.transform(this.selectedStartDate, fmt) ?? '' : '';
    const end = this.selectedEndDate ? this.datePipe.transform(this.selectedEndDate, fmt) ?? '' : '';
    this.formattedDateRange = start ? `${start} - ` : '';
    this.formattedDateRange += end;
  }

}
